import React from 'react';
import styles from './BackgroundCircle.module.scss';

export interface BackgroundCircleProps {
  // Position props
  top?: string | number;
  left?: string | number;
  right?: string | number;
  bottom?: string | number;

  // Size props (optional overrides)
  width?: string | number;
  height?: string | number;

  // Additional styling
  className?: string;
  style?: React.CSSProperties;

  // Animation props
  animation?: 'none' | 'float' | 'pulse' | 'glow';
  animationDuration?: string;
  animationDelay?: string;
}

const BackgroundCircle: React.FC<BackgroundCircleProps> = ({
  top,
  left,
  right,
  bottom,
  width,
  height,
  className = '',
  style = {},
  animation = 'none',
  animationDuration = '3s',
  animationDelay = '0s',
}) => {
  const positionStyle: React.CSSProperties = {
    position: 'absolute',
    top: top,
    left: left,
    right: right,
    bottom: bottom,
    width: width,
    height: height,
    zIndex: -1,
    pointerEvents: 'none',
    ...style,
  };

  const animationStyle: React.CSSProperties = {
    animationDuration,
    animationDelay,
  };

  const classes = [
    styles.backgroundCircle,
    animation !== 'none' && styles[`animation-${animation}`],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} style={{ ...positionStyle, ...animationStyle }}>
      {/* Desktop Circle */}
      <img
        src="/background-circles/desktop-circle.svg"
        alt=""
        aria-hidden="true"
        loading="lazy"
        className={styles.desktopCircle}
      />

      {/* Tablet Circle */}
      <img
        src="/background-circles/tablet-circle.svg"
        alt=""
        aria-hidden="true"
        loading="lazy"
        className={styles.tabletCircle}
      />

      {/* Mobile Circle */}
      <img
        src="/background-circles/mobile-circle.svg"
        alt=""
        aria-hidden="true"
        loading="lazy"
        className={styles.mobileCircle}
      />
    </div>
  );
};

export default BackgroundCircle;
